import * as React from 'react';
import styled from 'styled-components';
import Colors from '../lib/Colors';

function UnstyledInfoMessage(props: {
  children: React.ReactNode;
  className?: string;
}) {
  return <div className={props.className}>{props.children}</div>;
}

const InfoMessage = styled(UnstyledInfoMessage)`
  margin: 0.25rem 0;
  padding: 1rem;
  background-color: ${Colors.infoBackground};
  color: ${Colors.infoColor};
  font-size: 1rem;
`;

export default InfoMessage;



// WEBPACK FOOTER //
// ./src/components/InfoMessage.tsx